<template>
  <div>
    <!-- Boite nous joindre overridée avec le message de support custom -->
    <div v-if="overrideBoiteNousJoindreActif">
      <v-row
        class="boiteNousJoindre"
        style="background-color: #f2f2f2"
      >
        <v-row class="text-center mt-1 BoiteNousJoindre-ligne2">
          <v-col
            class="espaceurs"
            cols="1"
          ></v-col>
          <v-col cols="12">
            <div v-html="appStore.modele.optionRegionale.texteMessageSupport"></div>
          </v-col>
        </v-row>
      </v-row>
    </div>
    <!-- Boite nous joindre régulière -->
    <div v-else>
      <v-row
        class="boiteNousJoindre"
        style="background-color: #f2f2f2"
      >
        <v-col
          class="espaceurs"
          cols="1"
        ></v-col>
        <v-col
          cols="12"
          style="text-align: center; margin: auto; background-color: #f2f2f2"
        >
          <label class="px-3 texteBoite texteNousJoindre"> {{this.$t("BoiteNousJoindre.NousJoindre")}} </label>
          <v-img
            :src="appStore.modele.urlBase + '/images/telephone.png'"
            style="height: 25px; width: 25px; display: inline-block"
            class=""
          ></v-img>

          <label
            class="px-3 texteBoite texteNousJoindre"
            v-if="!peutSincrire"
          >{{$t("BoiteNousJoindre.NumeroTelephoneCSSP")}}</label>
          <label
            class="px-3 texteBoite texteNousJoindre"
            v-if="peutSincrire"
          >{{$t("BoiteNousJoindre.NumeroTelephoneMV")}}</label>
          <div v-if="peutSincrire">
            <v-img
              :src="appStore.modele.urlBase + '/images/aCommercial.png'"
              style="height: 25px; width: 25px; display: inline-block"
              class=""
            ></v-img>
            <label class="px-3 texteBoite texteNousJoindre">
              <a :href="appStore.modele.urlBase + '/#/DemandeContact'">{{$t("BoiteNousJoindre.FormulaireSupport")}}</a>
            </label>
          </div>
        </v-col>
      </v-row>

      <v-row
        v-if="peutSincrire"
        class="text-center mt-1 BoiteNousJoindre-ligne2"
      >
        <v-col
          class="espaceurs"
          cols="1"
        ></v-col>
        <v-col cols="12">
          <label class="texteBoite texteNousJoindre">
            {{$t("BoiteNousJoindre.DisponibleHoraire", { anneeCourante: new Date().getFullYear() })}}<b>{{$t("BoiteNousJoindre.HeureHoraire")}}<a
                href="pdf/GuideInscriptionCoursEte.pdf"
                target="_blank"
              >{{$t("BoiteNousJoindre.ConsulterGuide")}}</a></b>{{$t("BoiteNousJoindre.PourPlusInformation")}}
          </label>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import useAppStore from '@/store/appStore';

export default {
  name: 'BoiteNousJoindre',
  setup() {
    const appStore = useAppStore();

    return { appStore };
  },
  data() {
    return {
      overrideBoiteNousJoindreActif: false,
    };
  },
  methods: {
    allerDemandeContact() {
      window.open(`${this.appStore.modele.urlBase}/#/DemandeContact`, '_blank');
    },
  },
  computed: {
    peutSincrire() {
      return ((this.appStore.modele.optionRegionale.inscriptionOuverte && !this.appStore.modele.optionRegionale.inscriptionTermine) ||
        (this.appStore.modele.optionRegionale.inscriptionExamenOuverte && !this.appStore.modele.optionRegionale.inscriptionExamenTermine) || // Si pendant les inscription d'examen
        // eslint-disable-next-line max-len
        (!this.appStore.modele.optionRegionale.inscriptionOuverte && this.appStore.modele.optionRegionale.inscriptionTermine && !this.appStore.modele.optionRegionale.inscriptionExamenOuverte && !this.appStore.modele.optionRegionale.inscriptionExamenTermine)); // Si pas commencer mais pas terminé ( entre le moment que inscription normal sont fermé et inscription examen pas commencé)
    },
  },
  created() {
    // Déterminer s'il faut overrider le message selon les options régionales
    const dateActuelle = new Date();
    const messageSupportActif = this.appStore.modele.optionRegionale.estActifMessageSupport;
    let dateMessageSupportActive = false;
    if (dateActuelle > new Date(this.appStore.modele.optionRegionale.dateActifMessageSupport)) {
      dateMessageSupportActive = true;
    }

    if (messageSupportActif && dateMessageSupportActive) {
      this.overrideBoiteNousJoindreActif = true;
    }
  },
};
</script>

<style scoped>
.BoiteNousJoindre-ligne2 {
  margin-bottom: 0px;
  background-color: #f2f2f2;
}
</style>
